import * as React from 'react';
import { connect } from 'react-redux';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import { availableBrandFilterOptionsSelector, availableBrandFiltersSelector } from 'selectors/brand-filters/brandFilters';

import { __t, applyTranslations } from 'utils/language';

import './brands-dropdown.scss';

import type {
  Data,
  MixedSelectDropdownItem,
  SelectOption
} from 'types';

applyTranslations(require('../brands_filter_common.i18n.json'));

type OwnProps = {
  hideLabel?: boolean,
  activeBrandFilter?: string,
  onChange: (activeBrandFilter: string) => void,
  onMounted?: (options: Array<string>) => void
};

type StateProps = {
  brandFilters: Array<string>,
  brandFilterOptions: Array<SelectOption>
};

type Props = OwnProps & StateProps;

class BrandsDropdown extends React.PureComponent<Props> {
  componentDidMount() {
    const { onMounted, brandFilters } = this.props;

    if (onMounted) {
      onMounted(brandFilters);
    }
  }

  getDropdownItems = (): Array<MixedSelectDropdownItem> => {
    const { activeBrandFilter, brandFilterOptions } = this.props;

    return brandFilterOptions.map(item => ({
      identifier: item.value,
      isDisabled: false,
      isSelected: activeBrandFilter === item.value,
      label: item.label,
      value: item.value
    }));
  };

  handleChange = (
    updatedItems: Array<MixedSelectDropdownItem>,
    data?: Data | null,
    selectedItem?: Partial<MixedSelectDropdownItem> | null
  ): void => (
    this.handleChanged(selectedItem?.identifier || updatedItems[0].identifier)
  );

  handleChanged = (newBrandFilter: string) => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(newBrandFilter);
    }
  };

  render() {
    const { hideLabel, activeBrandFilter } = this.props;
    const dropdownItems = this.getDropdownItems();

    return dropdownItems.length > 1 ?
      (
        <div className="brands-dropdown">
          {
            !hideLabel && (
              <span className="brands-dropdown__select-label">
                {__t('brands_filter_common.label_filter_by')}:
              </span>
            )
          }
          <MixedSelectDropdown
            key={`brands-dropdown__${activeBrandFilter}`}
            name="brands-dropdown"
            items={dropdownItems}
            withSelectedInList
            className="brands-dropdown__dropdown"
            onItemsToggle={this.handleChange}
          />
        </div>
      ) :
      null;
  }
}


const mapStateToProps = (state): StateProps => {
  const brandFilters = availableBrandFiltersSelector(state);
  const brandFilterOptions = availableBrandFilterOptionsSelector(state);
  return {
    brandFilters,
    brandFilterOptions
  };
};

export default connect(mapStateToProps)(BrandsDropdown);
